var map = {
	"./StepIntoInnovation_bg.svg": 4676,
	"./about_us_header_img.png": 7145,
	"./about_us_imgs.png": 4474,
	"./advance_software_img.png": 5405,
	"./black_man.png": 2195,
	"./black_woman.png": 3897,
	"./cutting_edge_hardware_integration_img.png": 2347,
	"./delivery_guy.png": 8235,
	"./home-header-img.png": 6788,
	"./home-header-img.svg": 3586,
	"./home_hero_bg_annim.png": 9879,
	"./imgg.png": 8811,
	"./innovative_technology_img.png": 6425,
	"./international_conectivity_img.png": 3865,
	"./lgistics_hero_section_img.png": 4772,
	"./logistic_body_img.png": 4334,
	"./man_and_woman.png": 3846,
	"./mission_and_vallue_bg.svg": 125,
	"./our_journey_bg.svg": 7468,
	"./our_journey_img.png": 3292,
	"./our_journey_man.png": 8477,
	"./overview.png": 466,
	"./personalise_patient_img.png": 392,
	"./robust_data_collection_tools.png": 1070,
	"./security_and_compliance.png": 8497,
	"./telehealth_excellence_img.png": 3732,
	"./ticket_excellence_img.png": 7622,
	"./travels_and_tour_hero_section_img.png": 6618,
	"./turbham-logo.gif": 7791,
	"./turbham_travel_hero_section_img.png": 184,
	"./turbomedics_foundation_hero_section_img.png": 1929,
	"./turbomedics_hero_section_img.png": 2363,
	"./what_we_offer_bg.svg": 9159,
	"./why_choose_us_img1.svg": 8489,
	"./why_choose_us_img2.svg": 2490,
	"./why_choose_us_img3.svg": 4459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;